import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import axios from 'axios';
import Beatloader from '../../../Common/Loaders/Beatloader.jsx';
import { adminMainUrl } from '../../../Config.jsx';


const ApprovalDisapprovalContractModal = ({ show, handleClose, ContractInfo, contract_id, loadingContractInfo, CustomerProfileData, refresh }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const [showRejectionForm, setShowRejectionForm] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [customer_id, setCustomer_id] = useState(null);


    useEffect(() => {
        if (CustomerProfileData) {
            setCustomer_id(CustomerProfileData.id);
        }
    }, [CustomerProfileData])
    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            approval: "",
            rejection_reason: "",
        },
        validationSchema: Yup.object({}),
        onSubmit: async (values, { resetForm }) => {
            values.id = contract_id;
            values.customer_id = customer_id
            setIsSubmitting(true);
            try {
                axios.post(`${adminMainUrl}/api/customer/contract/approval`,
                    values, // The request payload
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'auth-token': Cookies.get('token'), // Assuming the token is stored in cookies
                            'user_id': Cookies.get('flexichain_user_id')
                        }
                    }
                ).then(response => {
                    if (response.status === 200) { // Check if the response is OK
                        toast.success(response.data?.msg);
                        handleClose();
                        setIsSubmitting(false);
                        resetForm();
                        formik.setFieldValue("approval", "")
                        formik.setFieldValue("committed_witness_signature", "");
                        setShowRejectionForm(false);
                        refresh();
                    } else {
                        toast.error(response.data?.msg);
                    }
                }).catch(error => {
                    setIsSubmitting(false);
                    if (error.response) {
                        toast.error(error.response.data?.msg || "An error occurred.");
                        console.error('Error disapproving document:', error.response.data?.message);
                    } else {
                        toast.error("Network error or server is unreachable.");
                        console.error('Network error:', error);
                    }
                });
            } catch (error) {
                setIsSubmitting(false);
                console.error('Network error:', error);
            }
        },
    });

    const handleAcceptance = (val) => {
        if (val == "APPROVED") {
            formik.setFieldValue("approval", val);
            setShowRejectionForm(false);
            formik.handleSubmit();

        } else if (val == "DISAPPROVED") {
            formik.setFieldValue("approval", val);
        }
    }


    useEffect(() => {
        if (formik.values.approval) {
            if (formik.values.approval == "APPROVED") { setShowRejectionForm(false); }
            if (formik.values.approval == "DISAPPROVED") { setShowRejectionForm(true); }
        }
    }, [formik.values.approval])

    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            {loadingContractInfo ?
                <Beatloader />
                :
                <>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Approve / Disapprove Contract</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="mb-3 mt-3">
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button className={`btn w-50 btn-outline-success ${formik.values.approval == "APPROVED" && "active"}`} type='button' onClick={() => handleAcceptance("APPROVED")}>&#x2713; Accept</button>
                                    </div>
                                    <div className="col-md-12 text-center mt-2">
                                        <button className={`btn w-50 btn-outline-danger ${formik.values.approval == "DISAPPROVED" && "active"}`} type='button' onClick={() => handleAcceptance("DISAPPROVED")} style={{ backgroundColor: "red !important" }}>&#10008; Reject</button>
                                    </div>
                                </div>
                                {
                                    showRejectionForm &&
                                    <>
                                        <label htmlFor="name" className="form-label">
                                            Disapproval Reason <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <textarea
                                            maxLength={3000}
                                            rows={5}
                                            className="form-control"
                                            id="rejection_reason"
                                            name="rejection_reason"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.rejection_reason}
                                        ></textarea>
                                    </>
                                }
                            </div>
                            {showRejectionForm && <div className="d-flex justify-content-end">
                                <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                                </button>
                            </div>}

                        </form>
                    </Offcanvas.Body>
                </>
            }

        </Offcanvas>
    )
}

export default ApprovalDisapprovalContractModal